import { Resolution } from 'types/Downloading';
import { PaidFeatures } from 'types/AppState';

export type TResolution = {
  resolution: Resolution;
  width: number;
  height: number;
  paid?: boolean;
};

export const RESOLUTIONS: TResolution[] = [
  {
    resolution: '360p',
    width: 540,
    height: 360
  },
  {
    resolution: '480p',
    width: 720,
    height: 480
  },
  {
    resolution: '720p',
    width: 1080,
    height: 720
  },
  {
    resolution: '1080p',
    width: 1920,
    height: 1080,
    paid: true
  },
  {
    resolution: '4k',
    width: 3240,
    height: 2160,
    paid: true
  }
];

export enum PremiumItemSource {
  Picsart = 'picsart',
  Shutterstock = 'shutterstock',
  Unsplash = 'unsplash'
}

export const PremiumItemSourceByType = {
  [PaidFeatures.PhotoChooser]: PremiumItemSource.Picsart,
  [PaidFeatures.Background]: PremiumItemSource.Picsart,
  [PaidFeatures.ShutterstockPhoto]: PremiumItemSource.Shutterstock,
  [PaidFeatures.Unsplash]: PremiumItemSource.Unsplash
};

export type OtpPremiumItems = Record<PaidFeatures, { name: string; showCount?: boolean }>;

export const PREMIUM_ITEMS: OtpPremiumItems = {
  [PaidFeatures.TextPreset]: {
    name: 'Font',
    showCount: true
  },
  [PaidFeatures.ShutterstockPhoto]: {
    name: 'Image',
    showCount: true
  },
  [PaidFeatures.ShutterstockVideo]: {
    name: 'Video',
    showCount: true
  },
  [PaidFeatures.PhotoChooser]: {
    name: 'Image',
    showCount: true
  },
  [PaidFeatures.Background]: {
    name: 'Background',
    showCount: true
  },
  [PaidFeatures.Unsplash]: {
    name: 'Unsplash',
    showCount: true
  },
  [PaidFeatures.VideoChooser]: {
    name: 'Video',
    showCount: true
  },
  [PaidFeatures.Template]: {
    name: 'Template'
  },
  [PaidFeatures.Mp4]: {
    name: 'Mp4'
  },
  [PaidFeatures.Resolution]: {
    name: 'Quality'
  },
  [PaidFeatures.Transition]: {
    name: 'Transition',
    showCount: true
  },
  [PaidFeatures.Audio]: {
    name: 'Audio'
  },
  [PaidFeatures.Font]: {
    name: 'Font',
    showCount: true
  }
};

export const GROUPABLE_PREMIUM_ITEMS = [
  PaidFeatures.Template,
  PaidFeatures.Mp4,
  PaidFeatures.Resolution,
  PaidFeatures.Transition,
  PaidFeatures.Font
];
